export const bgColor = '#F5F5F5';
export const bgHighlightColor = '#F000B4';
export	const txtColor = '#000';
export	const txtHighlightColor = '#EEE'
export	const txtDisabledColor = '#888';
